import React from "react";
import { DrawerPages, DrawerChapters, DrawerTopics } from "./HamburgerDrawerTypes";

const MenuTypes = {
  pages: DrawerPages,
  chapters: DrawerChapters,
  topics: DrawerTopics
};

const HamburgerMenus = ({
  menus,
  pageType,
  activeDrawer,
  setActiveDrawer,
  activeSlug,
  headerHeight,
  parentChapter
}) => {
  //console.log(menus);

  const JSX = MenuTypes[pageType];
  return JSX ? (
    <JSX
      menus={menus}
      headerHeight={headerHeight}
      activeDrawer={activeDrawer}
      setActiveDrawer={setActiveDrawer}
      pageType={pageType}
      slug={activeSlug}
      parentChapter={parentChapter}
    />
  ) : null;
};

export default HamburgerMenus;
